import React from "react";
import styled from "styled-components";
import textlogo from "../img/logo-text.png";
import { useStateContext } from "../global-context/useGlobalContext";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const { language } = useStateContext();
  const { pathname } = useLocation();
  return (
    <PhoneFooterWrapper>
      <h4>
        <a href="https://www.jcesardesign.com">
          <img
            src={textlogo}
            alt=""
          />{" "}
          <span> ® - 2023</span>
        </a>
      </h4>
      <div className="link-wrapper">
        <h4>
          <ul>
            <li>
              <Link
                to="/"
                className={pathname === "/" ? "onLink hover" : "hover"}
              >
                {language ? "Accueil" : "Home"}
              </Link>
            </li>
            <li>
              <Link
                to="/projects"
                className={pathname === "/projects" ? "onLink hover" : "hover"}
              >
                {language ? "Projets" : "Projects"}
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className={pathname === "/services" ? "onLink hover" : "hover"}
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={pathname === "/contact" ? "onLink hover" : "hover"}
              >
                Contact
              </Link>
            </li>
          </ul>
        </h4>

        <h4 className="contact">
          <span>Web Design :</span>
          <a
            href="mailto: robert@jcesardesign.com"
            className="hover"
          >
            robert@jcesardesign.com
          </a>
          <span>{language ? "Graphisme :" : "Graphic Design :"}</span>
          <a
            href="mailto: marine@jcesardesign.com"
            className="hover"
          >
            marine@jcesardesign.com
          </a>
          <a href="tel:+330781028463">+33 07 81 02 84 63</a>
        </h4>
      </div>
      <h4>
        {" "}
        <Link>{language ? "Mentions Légales" : "Legal Notice"}</Link>
      </h4>
    </PhoneFooterWrapper>
  );
};

export default Footer;

const PhoneFooterWrapper = styled.footer`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  height: fit-content;
  padding: 5vh 0;
  .link-wrapper {
    display: flex;
    justify-content: space-around;
    flex-direction: row;
    align-items: center;
    width: 100vw;
    padding: 5vh 10vw;
  }
  .contact {
    height: 25vh;
  }
  h4 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: fit-content;
    ul {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 25vh;
    }
    li {
      list-style: none;
    }
  }
  img {
    height: 1.5vh;
  }
  .onLink {
    border-bottom: 1px solid #f9cc0b;
  }
  .hover:hover {
    color: #f9cc0b;
  }
`;
